import React from 'react';
import { Menu, MenuItem, Avatar } from '@mui/material';
import { Typography, Box } from '@mui/material';
import { Logout, PublishedWithChanges, Sync } from '@mui/icons-material';

const UserMenu = ({ anchorEl, open, onClose, onLogout, onForceSync, onBulkCodeChanges, username }) => {
  const handleForceSync = () => {
    onForceSync();
    onClose();
  };

  const handleBulkCodeChanges = () => {
    onBulkCodeChanges();
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          minWidth: '200px',
          borderRadius: '20px', // Increased roundness
        },
      }}
    >
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Avatar sx={{ width: 50, height: 50, margin: '0 auto 8px', bgcolor: '#1976d2', fontSize: '1.7rem', fontWeight: 'bold' }}>
          {username.charAt(0).toUpperCase()}
        </Avatar>
        <Typography variant="body1" fontWeight="bold" sx={{ fontSize: '1.1rem' }}>Hi, {username}!</Typography>
      </Box>

      <MenuItem onClick={handleForceSync} sx={{ color: '#1976d2', width: '100%', padding: '8px 16px', '&:hover': { backgroundColor: 'f5f5f5' } }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Sync sx={{ mr: 1 }} />
          Force Sync
        </Box>
      </MenuItem>

      <MenuItem onClick={handleBulkCodeChanges} sx={{ color: '#1976d2', width: '100%', padding: '8px 16px', '&:hover': { backgroundColor: 'f5f5f5' } }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <PublishedWithChanges sx={{ mr: 1 }} />
          Bulk code changes
        </Box>
      </MenuItem>

      <MenuItem onClick={onLogout} sx={{ color: '#1976d2', width: '100%', padding: '8px 16px', '&:hover': { backgroundColor: 'f5f5f5' } }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Logout sx={{ mr: 1 }} />
          Logout
        </Box>
      </MenuItem>
      <Box sx={{ p: 0.7, textAlign: 'center' }}>
        <Typography variant="body1" fontWeight="bold" sx={{ fontSize: '0.5rem' }}>Ver 2.04.00</Typography>
      </Box>
    </Menu>
  );
};

export default UserMenu;
